<div mat-dialog-actions>

</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col-12 text-center">
      <h4>Please wait while we load your application and redirect you</h4>
    </div>
  </div>
  <div class="row pt-4 pb-3">
    <div class="col-12 text-center">
      <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    </div>
  </div>
</div>
